import React from 'react';
import { Header, Segment, Button, Icon } from 'semantic-ui-react';
import PolicyRate from '../PolicyRate';
import styles from './Conclusion.module.scss';

const Conclusion = ({ children, title, rate, policy, onExit }) => {
	return (
		<div>
			<Header className={`${styles.center} ${styles.green}`}>{title}</Header>
			<Segment>{children}</Segment>
			{rate && <PolicyRate rate={rate} policy={policy} />}

			<Header className={styles.center}>You will receive a confirmation email of this change shortly.</Header>
			<div className={styles.buttons}>
				<Button id="closeBtn" primary onClick={onExit}>
					Close
				</Button>
				<Button id="printBtn" icon primary onClick={() => window.print()}>
					<Icon name='print' />
					Print
				</Button>
			</div>
		</div>
	);
};

export default Conclusion;
